import { useState, useEffect, useRef, useCallback } from "react";
import { FileUploader, Modal } from "../../components";
import Form, { RequiredRule, SimpleItem } from "devextreme-react/form";
import BaseService from "../../services";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import moment from "moment";
import { BodyType, createRequest } from "../../redux/base/request";
import {
  OpenTicket,
  SelectTicket,
  SendAnswer,
  TicketAnswer,
  TicketStatus,
  TicketStatusTypes,
} from "./types";
import { GroupItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import ScrollView from "devextreme-react/scroll-view";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import List from "devextreme-react/list";
import { FiMessageSquare } from "react-icons/fi";
import { getLocalized } from "../../redux/localization";
import "./style.scss";
import image from "../../assets/images/logo.png";
import { baseUrl, imageUrl } from "../../services/urls";
import notify from "devextreme/ui/notify";
import { ChangeStatusModal } from "./status";
import { useLocation } from "react-router-dom";

const TicketManagement = () => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const baseService = new BaseService();
  const data1 = useRef<SendAnswer>({ Message: "", Document: "" });
  const [datas, setDatas] = useState<OpenTicket[]>();
  const [status, setStatus] = useState(false);
  const localize = useSelector(getLocalized);
  const [selected, setSelected] = useState<SelectTicket>();
  const [show, setShow] = useState(false);
  const { token, lang } = useSelector(getApiParams);
  const location = useLocation();
  const formRef = useRef<any>();
  const [sorted, setSorted] = useState<TicketAnswer[]>();
  const [ticketstatusTypes, setTicketStatusTypes] = useState<
    TicketStatusTypes[]
  >([]);
  const ticketstatus = useRef<TicketStatus>({
    ticketId: "",
    ticketStatusId: 0,
  });
  const [scrollDatas] = useState({
    showScrollBarMode: "onScroll",
    pullDown: false,
    scrollByContent: true,
    scrollByThumb: true,
  });
  const scrollRef = useRef<HTMLDivElement>(null);
  const userId = "a4df4181-718f-49c1-87b8-ee72084aa009";

  const getTickets = useCallback(async () => {
    const search = location.search;

    const res: any | null = await baseService.sendRequestWithApiResponse(
      baseUrl + "api/admin/tickets",
      "GET",
      token,
      lang,
      BodyType.formdata
    );
    if (res) {
      const newDatas = res.Result?.sort(
        (a: any, b: any) => Date.parse(b.CreateTime) - Date.parse(a.CreateTime)
      );
      search !== "" && getMessages(search.replace("?selectedTicket=", ""));
      setDatas(newDatas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, lang]);

  const getMessages = async (id: any) => {
    const res: any | null = await baseService.sendRequestWithApiResponse(
      baseUrl + "api/admin/tickets/" + id,
      "GET",
      token,
      lang,
      BodyType.formdata
    );
    if (res) {
      setSelected(res.Result);
      const x = res.Result.TicketAnswers.sort(
        (a: any, b: any) => Date.parse(a.CreateTime) - Date.parse(b.CreateTime)
      );
      setSorted(x);
      setStatus(true);
      //setNewSelect(selected)
      //@ts-ignore
      scrollRef?.current?.scrollIntoView();
      document.getElementById("scrollView")?.scrollIntoView();
    }
  };
  const getTicketsStatusTypes = useCallback(async () => {
    const response: ApiResponse<TicketStatusTypes[]> = await createRequest({
      method: "GET",
      url: "/api/admin/tickets/get-ticket-status-types",
      bodyType: BodyType.formdata,
      token,
      body: {},
      lang,
    });
    if (verfiyResponse(response)) {
      setTicketStatusTypes(response.Result);
    }
  }, [token, lang]);

  useEffect(() => {
    //@ts-ignore
    scrollRef?.current?.scrollIntoView();
    document.getElementById("scrollView")?.scrollIntoView();
  }, [sorted]);
  useEffect(() => {
    getTickets();
    getTicketsStatusTypes();
  }, [getTickets, getTicketsStatusTypes]);

  const updateTicket = async () => {
    const response: ApiResponse<TicketStatus> = await createRequest({
      method: "POST",
      url: "/api/admin/tickets/update-status",
      bodyType: BodyType.raw,
      token,
      body: ticketstatus.current,
      lang,
    });

    if (verfiyResponse(response)) {
      notify(response.Message, "warning");
    }
  };
  function ItemTemplate(data: OpenTicket) {
    return (
      <div
        className="ticket-list-item"
        id={data.Id}
        onClick={() => {
          getMessages(data.Id);
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="ticket-list-avatar">
            <img src={image} className="avatar-icon" alt=""></img>
          </div>
          <div className="ticket-list-info">
            <div className="ticket-list-title1">{data.UserName}</div>
            <div className="ticket-list-title">{data.TicketStatusType}</div>
            <div className="ticket-list-title">
              {moment.utc(data.CreateTime).fromNow()}
            </div>
          </div>
        </div>
        {/* <div>
          <Toolbar className='ticket-detail'>
            <Item locateInMenu="always"
              widget="dxButton"
              text={"Düzenle"}
              cssClass="edit-user"
            />
          </Toolbar>
        </div> */}
      </div>
    );
  }

  const customizeItem = (item: any) => {
    if (item.dataField === "Message" || item.dataField === "Document") {
      item.validationRules = [
        {
          type: "required",
          message: "Zorunlu",
        },
        {
          type: "required",
          message: "zorunlu",
        },
      ];
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div>
        <p
          style={{
            fontSize: "24px",
            fontWeight: "600",
          }}
        >
          {localize.getString("ticketManagement")}
        </p>
      </div>
      <div
        style={{
          display: "flex",
          maxWidth: "1100px",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1",
            backgroundColor: "white",
            padding: "10px",
            marginRight: "30px",
            display: "flex",

            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "620px",
            }}
          >
            <div className="list-container">
              <List
                dataSource={datas}
                height={600}
                itemRender={ItemTemplate}
                searchExpr="TicketType"
                scrollByThumb={true}
                searchEnabled={true}
                selectionMode={"single"}
                searchMode={"contains"}
              />
            </div>
          </div>
        </div>
        <div className={selected ? "Var" : "Yok"}>
          <div className={`content-${status === true ? `var` : `yok`}`}>
            <FiMessageSquare size="4em"></FiMessageSquare>
            <h5>{localize.getString("startChat")}</h5>
          </div>
          <div className="right-side">
            <ul className="ticket-list">
              <li className="ticket-list-item">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div className="header-top">
                    <div className="ticket-list-avatar">
                      <img className="avatar-icon" src={image} alt=""></img>
                    </div>
                    <div>
                      <p className="ticket-info-title">{selected?.UserName}</p>
                    </div>
                  </div>
                  <div className="header-bottom">
                    <div>
                      <p className="ticket-info-title">
                        {localize.getString("subject")} :{" "}
                        <label className="title-item">
                          {selected?.Subject}
                        </label>
                      </p>
                    </div>
                    <div>
                      <p className="ticket-info-title">
                        {localize.getString("ticketType")} :{" "}
                        <label className="title-item">
                          {selected?.TicketType}
                        </label>{" "}
                      </p>
                    </div>
                    <div>
                      <p className="ticket-info-title">
                        {localize.getString("code")} :{" "}
                        <label className="title-item">{selected?.Code}</label>{" "}
                      </p>
                    </div>
                    <div>
                      <p className="ticket-info-title">
                        {localize.getString("ticketStatusType")} :{" "}
                        <label className="title-item">
                          {selected?.TicketStatusType}
                        </label>{" "}
                      </p>
                    </div>
                    <div>
                      <Button
                        text="Durum Değiştir"
                        className="status-button"
                        onClick={() => {
                          setShow(true);
                        }}
                      ></Button>
                    </div>
                    <Modal
                      visible={show}
                      width="40%"
                      height="30%"
                      onHiding={() => {
                        setShow(false);
                      }}
                      title={"Durum Değiştirme Formu"}
                      onSubmitClick={() => {
                        updateTicket();
                      }}
                    >
                      <ChangeStatusModal
                        data={ticketstatus.current}
                        ref={formRef}
                        ticketstatusTypes={ticketstatusTypes}
                        id={selected?.Id}
                      ></ChangeStatusModal>
                    </Modal>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div id="scroll" className="right-scroll">
            <ScrollView
              id="scrollview"
              scrollByContent={scrollDatas.scrollByContent}
              bounceEnabled={scrollDatas.pullDown}
              showScrollbar={"onScroll"}
              scrollByThumb={scrollDatas.scrollByThumb}
            >
              <div className="text-content" ref={scrollRef}>
                {sorted?.map((data, key) => (
                  <div key={key} ref={scrollRef}>
                    <div
                      className={`message-text-${
                        data.CreatedUserId === userId ? `right` : `left`
                      }`}
                    >
                      <p>{data.Message}</p>
                      {data?.DocumentLocation !== "" && (
                        <img
                          src={imageUrl + data?.DocumentLocation}
                          alt=""
                          className="ticket-image"
                        ></img>
                      )}
                      <p className="time-left">
                        {" "}
                        {moment.utc(data.CreateTime).fromNow()}{" "}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollView>
          </div>
          <div className="form-content">
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-around",
                }}
              >
                <Form
                  labelLocation="left"
                  formData={data1.current}
                  showColonAfterLabel={true}
                  customizeItem={customizeItem}
                  onEditorEnterKey={async (e: any) => {
                    if (e.event.code === "Enter") {
                      const response: ApiResponse<SendAnswer> =
                        await createRequest({
                          method: "POST",
                          url:
                            "/api/admin/tickets/post-ticket-answer/" +
                            selected?.Id,
                          bodyType: BodyType.formdata,
                          token,
                          body: data1.current,
                          lang,
                        });
                      if (verfiyResponse(response)) {
                        data1.current = { Message: "", Document: "" };
                        getMessages(selected?.Id);
                      }
                    }
                  }}
                >
                  <GroupItem colCount={2} cssClass="form-column">
                    <SimpleItem
                      dataField="Message"
                      cssClass="message-bar"
                      editorType={"dxTextBox"}
                      label={{ text: localize.getString("message") }}
                      editorOptions={{
                        inputAttr: {
                          style: " text-transform: capitalize",
                        },
                      }}
                    >
                      <RequiredRule message={localize.getString("required")} />
                    </SimpleItem>
                    <SimpleItem
                      dataField="Document"
                      cssClass="file-bar"
                      label={{ text: localize.getString("file") }}
                    >
                      <FileUploader
                        buttonText={localize.getString("file")}
                        onValueChanged={(values) =>
                          (data1.current.Document = values[0])
                        }
                      />
                    </SimpleItem>
                  </GroupItem>
                </Form>
                <Button
                  visible={true}
                  className="datagrid-action-button"
                  text={localize.getString("send")}
                  type="success"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "50px",
                    width: "100px",
                    padding: "0",
                    height: "35px",
                  }}
                  stylingMode="contained"
                  onClick={async () => {
                    const response: ApiResponse<SendAnswer> =
                      await createRequest({
                        method: "POST",
                        url:
                          "/api/admin/tickets/post-ticket-answer/" +
                          selected?.Id,
                        bodyType: BodyType.formdata,
                        token,
                        body: data1.current,
                        lang,
                      });
                    if (verfiyResponse(response)) {
                      data1.current = { Message: "", Document: "" };
                      getMessages(selected?.Id);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketManagement;
